"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewParser = void 0;
var tslib_1 = require("tslib");
var view_1 = require("@catalytic/view");
var remark_parse_1 = require("remark-parse");
var unherit_1 = tslib_1.__importDefault(require("unherit"));
var handlebars_1 = tslib_1.__importDefault(require("./tokenize/handlebars"));
var mention_1 = tslib_1.__importDefault(require("./tokenize/mention"));
var RemarkParser = unherit_1.default(remark_parse_1.Parser);
var ViewParser = (function (_super) {
    tslib_1.__extends(ViewParser, _super);
    function ViewParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViewParser.prototype.setOptions = function (options) {
        var _a;
        var _b = this.options, _c = _b.role, role = _c === void 0 ? view_1.Role.READER : _c, _d = _b.views, views = _d === void 0 ? {} : _d;
        _super.prototype.setOptions.call(this, {});
        this.options = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ role: role }, ViewParser.prototype.options), options), { views: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (((_a = ViewParser.prototype.options) === null || _a === void 0 ? void 0 : _a.views) || {})), views), ((options === null || options === void 0 ? void 0 : options.views) || {})) });
    };
    ViewParser.registerInlineMethods = function (methods) {
        Object.entries(methods).reduce(function (p, _a) {
            var method = _a[0], tokenizer = _a[1];
            p.inlineMethods.splice(p.inlineMethods.indexOf('text'), 0, method);
            p.inlineTokenizers[method] = tokenizer;
            return p;
        }, ViewParser.prototype);
    };
    return ViewParser;
}(RemarkParser));
exports.ViewParser = ViewParser;
ViewParser.registerInlineMethods({
    mention: mention_1.default,
    handlebars: handlebars_1.default
});
//# sourceMappingURL=parser.js.map